import { RouteRecordRaw } from 'vue-router'
import { EventVisibility } from '@/modules/config'

const Home = () => import('@/views/Home.vue')
const Events = () => import('@/views/Events.vue')
const CreateEvent = () => import('@/views/CreateEvent.vue')
const Event = () => import('@/views/Event.vue')
const Profile = () => import('@/views/Profile.vue')
const MemberProfile = () => import('@/views/MemberProfile.vue')
const GuestProfile = () => import('@/views/GuestProfile.vue')
const Invitation = () => import('@/views/Invitation.vue')
const SignUp = () => import('@/views/SignUp.vue')
const SignIn = () => import('@/views/SignIn.vue')
const ResetPassword = () => import('@/views/ResetPassword.vue')
const Auth = () => import('@/views/Auth.vue')
const Fallback = () => import('@/views/Fallback.vue')
const ManageProfile = () => import('@/views/ManageProfile.vue')

const NotificationSettings = () =>
  import('@/views/settings/NotificationSettings.vue')

// Admin routes
// TODO: Harmonise naming
const EditTeam = () => import('@/views/admin/EditTeam.vue')
const EditMembers = () => import('@/views/admin/EditMembers.vue')
const EditLocations = () => import('@/views/admin/EditLocations.vue')
const ManageEvents = () => import('@/views/admin/ManageEvents.vue')
const ManageInvitations = () => import('@/views/admin/ManageInvitations.vue')
const CreateNews = () => import('@/views/admin/CreateNews.vue')

const visibilityMapper =
  (visibility: EventVisibilityValue) => (record: RouteRecordRaw) => ({
    ...record,
    meta: { visibility, ...record.meta }
  })

const publicRoutes: RouteRecordRaw[] = [
  {
    path: '/silly-you',
    name: 'ResetPassword',
    component: ResetPassword,
    meta: { hideNav: true }
  },
  { path: '/auth', name: 'Auth', component: Auth, meta: { hideNav: true } },
  {
    path: '/invitation/:teamId/:inviteId',
    name: 'Invitation',
    component: Invitation,
    meta: { hideNav: true }
  },
  {
    path: '/sign-in',
    name: 'SignIn',
    component: SignIn,
    meta: { hideNav: true }
  },
  {
    path: '/get-started',
    name: 'SignUp',
    component: SignUp,
    meta: { hideNav: true }
  },
  {
    path: '/:pathMatch(.*)*',
    name: '404',
    component: Fallback,
    meta: { hideNav: true }
  }
]

const memberRoutes: RouteRecordRaw[] = [
  { path: '/', redirect: '/home' },
  { path: '/home', name: 'Home', component: Home },
  { path: '/events', name: 'Events', component: Events },
  { path: '/events/create', name: 'CreateEvent', component: CreateEvent },
  { path: '/event/:id', name: 'Event', component: Event, props: true },
  { path: '/profile', name: 'Profile', component: Profile },
  { path: '/profile/:id', name: 'MemberProfile', component: MemberProfile },
  { path: '/profile/manage', name: 'ManageProfile', component: ManageProfile },
  {
    path: '/event/:eventId/guest/:guestId',
    name: 'GuestProfile',
    component: GuestProfile,
    props: true
  },
  {
    path: '/settings/notifications',
    name: 'NotificationSettings',
    component: NotificationSettings
  }
]

const adminRoutes: RouteRecordRaw[] = [
  { path: '/admin/edit-team', name: 'EditTeam', component: EditTeam },
  { path: '/admin/edit-members', name: 'EditMembers', component: EditMembers },
  {
    path: '/admin/edit-locations',
    name: 'EditLocations',
    component: EditLocations
  },
  {
    path: '/admin/manage-events',
    name: 'ManageEvents',
    component: ManageEvents
  },
  {
    path: '/admin/manage-invitations',
    name: 'ManageInvitations',
    component: ManageInvitations
  },
  { path: '/admin/news/create', name: 'CreateNews', component: CreateNews }
]

export default [
  ...publicRoutes.map(visibilityMapper(EventVisibility.Public)),
  ...memberRoutes.map(visibilityMapper(EventVisibility.Member)),
  ...adminRoutes.map(visibilityMapper(EventVisibility.Admin))
]
